import React from 'react';
import FinanceCalculatorCard from './components/FinanceCalculatorCard';

export default function FinanceCalculator() {
  return (
    <div className={'container'}>
      <FinanceCalculatorCard />
    </div>
  );
}
